import React from 'react';
import { Button, Form } from 'antd';
import AmountInstance from './AmountInstance';

const AmountOrder = ({ path, outerName }) => {
  return (
    <Form.List name={[outerName, 'amounts']}>
      {(fields, { add, remove, move }) => {
        const canRemoveOrMove = fields.length > 1;

        return (
          <>
            {fields.map(({ key, name, ...restField }) => (
              <AmountInstance
                key={key}
                path={path}
                outerName={outerName}
                name={name}
                restField={restField}
                remove={canRemoveOrMove ? () => remove(name) : null}
                moveUp={
                  canRemoveOrMove && name !== 0
                    ? () => move(name, name - 1)
                    : null
                }
                moveDown={
                  canRemoveOrMove && name !== fields.length - 1
                    ? () => move(name, name + 1)
                    : null
                }
              />
            ))}

            <Form.Item>
              <Button
                type="primary"
                onClick={() => add()}
                block
              >
                Add Additional Discount Amount
              </Button>
            </Form.Item>
          </>
        );
      }}
    </Form.List>
  );
};

export default AmountOrder;
